export default __webpack_public_path__ + "static/media/step4.51a206a1.png";